import React from 'react';
import Icon from './UI/Icon';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section bg-navy">
      {/* Top Footer Area */}
      <div className="container footer-container">
        
        {/* Brand Showcase Block */}
        <div className="footer-brand-column">
          <a href="#home" className="footer-logo-badge">
            <img 
              src="/assets/logo.png" 
              alt="Active Joint Physiotherapy" 
              className="footer-logo-img" 
            />
          </a>
          <p className="footer-brand-desc">
            Helping patients across children, adult, and senior age groups live pain-free, active, and independent lives through personalized care.
          </p>
        </div>

        {/* Sitemap Navigation links */}
        <div className="footer-links-column">
          <h4>Quick Links</h4>
          <ul className="footer-links-list">
            <li><a href="#home">Home</a></li>
            <li><a href="#specializations">Specializations</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Treatments</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Services column shortcuts */}
        <div className="footer-links-column">
          <h4>Rehab Services</h4>
          <ul className="footer-links-list">
            <li><a href="#services">Ortho Rehabilitation</a></li>
            <li><a href="#services">Neuro Rehabilitation</a></li>
            <li><a href="#services">Sports Injury Care</a></li>
            <li><a href="#services">Post-Surgery recovery</a></li>
            <li><a href="#services">Custom Exercise Plans</a></li>
          </ul>
        </div>

        {/* Address & Timings Column */}
        <div className="footer-contact-column">
          <h4>Clinic Details</h4>
          <ul className="footer-contact-list">
            <li>
              <Icon name="mappin" size={16} className="footer-info-icon" />
              <span>Active Joint Physiotherapy & Sports Rehabilitation Clinic</span>
            </li>
            <li>
              <Icon name="phone" size={16} className="footer-info-icon" />
              <a href="tel:8826265224">8826265224</a>
            </li>
            <li>
              <Icon name="mail" size={16} className="footer-info-icon" />
              <a href="mailto:activejoint1@gmail.com">activejoint1@gmail.com</a>
            </li>
            <li>
              <Icon name="clock" size={16} className="footer-info-icon" />
              <span>Mon - Sat: 9:00 AM - 8:00 PM <br />(Prior Booking Recommended)</span>
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom Copyright details strip */}
      <div className="footer-bottom-bar">
        <div className="container bottom-bar-container">
          <p className="copyright-text">
            &copy; {currentYear} Active Joint Physiotherapy & Sports Rehabilitation Clinic. All rights reserved.
          </p>
          <div className="developer-signature">
            <span>Designed By <a href="https://www.skorasoft.com/" target="_blank" rel="noopener noreferrer">SkoraSoft</a></span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
